import { el, on } from '@/lib/dom';

export type SelectOpts = {
  label: string;
  value: string;
  options: readonly string[];
  labels?: Record<string, string>;
  onChange: (v: string) => void;
};

export function selectControl(opts: SelectOpts): HTMLElement {
  const sel = el('select', { class: 'sel-input', ariaLabel: opts.label });
  for (const o of opts.options) {
    const optEl = el('option', { value: o });
    optEl.textContent = opts.labels?.[o] ?? o;
    sel.appendChild(optEl);
  }
  sel.value = opts.value;
  on(sel, 'change', () => opts.onChange(sel.value));

  return el('div', { class: 'sel' }, [
    el('div', { class: 'sl-row' }, [
      el('span', { class: 'sl-label' }, [opts.label]),
    ]),
    sel,
  ]);
}
